<template>

    <div class="width-full doc-page">
        <v-container fluid grid-list-xl class="general-container">
            <v-layout row wrap class="navigation-header">
                <v-flex xs12>
                    <header-bar></header-bar>
                </v-flex>
            </v-layout>

            <div class="scrolling-content-doc">
                <v-layout row wrap class="page-content">
                    <v-flex xl8 md8 sm8 xs12 align-start class="no-padding doc-title">
                        <img
                             v-if="!getRole"
                             alt="back icon"
                             src="../../../assets/svg/material-icons-alternatives/chatbot/Arrow_back.svg"
                             width="24px" height="24px"
                             @click="goToHomePage"
                                     >
                        <h2 class="page-title">{{ text('api.doc.pro.' + docCode) }}</h2>
                    </v-flex>
                    <v-flex  v-if="getDocData" v-html="getDocData.content" xs12 class="doc-content">

                    </v-flex>
                </v-layout>
            </div>
        </v-container>

        <div class="cookies-display">
            <accept-cookie></accept-cookie>
        </div>
    </div>
</template>

<!-- ################################################################## -->

<script>
    import { mapGetters} from 'vuex';
    import HeaderBar from "../../../professional/components/shared/HeaderBar";
    import AcceptCookie from '../../../professional/components/cookies/AcceptCookie';

    export default {
        name: 'DocPage',
        components: {
            HeaderBar,
            AcceptCookie
        },

        computed: {
            ...mapGetters({
                getSelectedLang: 'TranslationStore/getSelectedLang',
                getAppPropertyValue: 'TranslationStore/getAppPropertyValue',
                getDocData: 'DocStore/getDocData',
                getRole: 'UserStore/getRole',
                getDocApplicationType: 'TranslationStore/getDocApplicationType'
            }),

            docCode() {
                return this.$route.query.type;
            }
        },

        mounted() {
            this.loadDocPage();
        },

        beforeDestroy() {
          this.$store.commit("DocStore/setDocData", null);
        },

        watch: {
            docCode(newCode, oldCode) {
                if (newCode !== oldCode) {
                    this.loadDocPage();
                }
            }

        },

        methods: {

            loadDocPage () {
                const applicationType = this.getDocApplicationType();
                if (!this.$route.query.type || this.getAppPropertyValue("DOC_" + applicationType + "_ADDRESS_" + this.$route.query.type) === null ) {
                    this.$router.push('/');
                }

                this.$store.commit('DocStore/setDocData', null);

                const data = {
                    title: 'api.doc.' + applicationType.toLowerCase() + '.' + this.docCode,
                    url: this.getAppPropertyValue("DOC_" + applicationType + "_ADDRESS_" + this.docCode),
                }

                this.$store.dispatch('DocStore/loadDocData', data)
                    .then(() => {
                        // Without this the axios requests get a new base URL because of the external
                        // html of the docs page
                        // the tag <base href=""> needs to be removed after the content is loaded
                        this.$nextTick(() => {
                            document.querySelector(".doc-content base").remove();
                        })
                    });
            },

            goToHomePage() {
                this.$router.push('/');
            }

        }
    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>

    .scrolling-content-doc {
        top: 85px;
        position: fixed;
        margin-left: auto;
        margin-right: auto;
        overflow: auto;
        width: 100%;
        padding-top: 20px;
        bottom: 10px;
    }

    .doc-content {
        background-color: white;
        border-radius: 4px;
        padding: 20px !important;
        margin: 20px;
    }

    .doc-title {
        margin-top: 15px;
        margin-left: 20px;
        display: flex;
        align-items: center;

        img {
            cursor: pointer;
            margin-right: 10px;
        }

        .page-title {
            font-weight: 300;
        }
    }

</style>





// WEBPACK FOOTER //
// src/common/components/documentation/DocPage.vue